import { render, staticRenderFns } from "./PapasMergeQuestionsActionSelection.vue?vue&type=template&id=0ba01fa7&scoped=true"
import script from "./PapasMergeQuestionsActionSelection.vue?vue&type=script&lang=js"
export * from "./PapasMergeQuestionsActionSelection.vue?vue&type=script&lang=js"
import style0 from "./PapasMergeQuestionsActionSelection.vue?vue&type=style&index=0&id=0ba01fa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba01fa7",
  null
  
)

export default component.exports